// app/javascript/compcalc/components/AppMenuListItems.jsx

import React from 'react';
import { Link } from 'react-router-dom';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import CommIcon from './icons/commutation.png';
import CVEIcon from './icons/cve.png';
import DateCalcIcon from './icons/date-calc.png';
import DeathBenefitsIcon from './icons/death-benefits.png';
import FutureValueIcon from './icons/future-value.png';
import JobDisplIcon from './icons/job-displ.png';
import LifeExpIcon from './icons/life-exp.png';
import LifePensionIcon from './icons/life-pension.png';
import PDRatingIcon from './icons/pd-rating.png';
import PermDisIcon from './icons/perm-dis.png';
import QMEIcon from './icons/qme.png';
import TempDisIcon from './icons/temp-dis.png';
import SupportIcon from './icons/support.png';
import AboutIcon from './icons/about.png';


const AppMenuListItems = (props) => (
  <div>
    <ListItem button dense margin="none" selected={props.drawerIndex === 0} onClick={() => props.drawerIndexChanged(0)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="PD Ratings" src={ PDRatingIcon } />
      </ListItemIcon>
      <ListItemText primary="Permanent Disability Rating Manual / Schedule" />
    </ListItem>
    <ListItem button dense margin="none" selected={props.drawerIndex === 1} onClick={() => props.drawerIndexChanged(1)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="Permanent Disability" src={ PermDisIcon } />
      </ListItemIcon>
      <ListItemText primary="Permanent Disability Indemnity" />
    </ListItem>
    <ListItem button dense margin="none" selected={props.drawerIndex === 2} onClick={() => props.drawerIndexChanged(2)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="Temporary Disability" src={ TempDisIcon } />
      </ListItemIcon>
      <ListItemText primary="Temporary Total Disability" />
    </ListItem>
    <ListItem button dense margin="none" selected={props.drawerIndex === 3} onClick={() => props.drawerIndexChanged(3)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="Commutation" src={ CommIcon } />
      </ListItemIcon>
      <ListItemText primary="Commutation of Attorney's Fees" />
    </ListItem>
    <ListItem button dense margin="none" selected={props.drawerIndex === 4} onClick={() => props.drawerIndexChanged(4)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="Life Pension" src={ LifePensionIcon } />
      </ListItemIcon>
      <ListItemText primary="Life Pension" />
    </ListItem>
    <ListItem button dense margin="none" selected={props.drawerIndex === 5} onClick={() => props.drawerIndexChanged(5)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="Future Value" src={ FutureValueIcon } />
      </ListItemIcon>
      <ListItemText primary="Future Value / Present Value / COLA Calculator" />
    </ListItem>
    <ListItem button dense margin="none" selected={props.drawerIndex === 6} onClick={() => props.drawerIndexChanged(6)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="Life Expectancy" src={ LifeExpIcon } />
      </ListItemIcon>
      <ListItemText primary="Life Expectancy" />
    </ListItem>
    <ListItem button dense margin="none" selected={props.drawerIndex === 7} onClick={() => props.drawerIndexChanged(7)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="Job Displacement" src={ JobDisplIcon } />
      </ListItemIcon>
      <ListItemText primary="Job Displacement" />
    </ListItem>
    <ListItem button dense margin="none" selected={props.drawerIndex === 8} onClick={() => props.drawerIndexChanged(8)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="Death Benefits" src={ DeathBenefitsIcon } />
      </ListItemIcon>
      <ListItemText primary="Death Benefits" />
    </ListItem>
    <ListItem button dense margin="none" selected={props.drawerIndex === 9} onClick={() => props.drawerIndexChanged(9)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="Date Calculator" src={ DateCalcIcon } />
      </ListItemIcon>
      <ListItemText primary="Date Calculator" />
    </ListItem>
    <ListItem button dense margin="none" selected={props.drawerIndex === 10} onClick={() => props.drawerIndexChanged(10)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="QME" src={ QMEIcon } />
      </ListItemIcon>
      <ListItemText primary="QME/Body Part Codes" />
    </ListItem>
    <ListItem button dense margin="none" selected={props.drawerIndex === 11} onClick={() => props.drawerIndexChanged(11)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="Combined Value Equation" src={ CVEIcon } />
      </ListItemIcon>
      <ListItemText primary="Combined Value Equation" />
    </ListItem>
    <ListItem button dense margin="none" selected={props.drawerIndex === 12} onClick={() => props.drawerIndexChanged(12)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="Support & Training" src={ SupportIcon } />
      </ListItemIcon>
      <ListItemText primary="Support & Training" />
    </ListItem>
    <ListItem button dense margin="none" selected={props.drawerIndex === 13} onClick={() => props.drawerIndexChanged(13)}>
      <ListItemIcon>
        <img style={{ width: 48, height: 48 }} alt="About This Program" src={ AboutIcon } />
      </ListItemIcon>
      <ListItemText primary="About This Program" />
    </ListItem>
  </div>
);

export default AppMenuListItems;
